/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Addon_LabelInputs */

const en_shipping_addon_label = /** @type {(inputs: Shipping_Addon_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly Shipping Fee Surcharge`)
};

const es_shipping_addon_label = /** @type {(inputs: Shipping_Addon_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recargo Mensual de Envío`)
};

const fr_shipping_addon_label = /** @type {(inputs: Shipping_Addon_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supplément mensuel de frais de port`)
};

const de_shipping_addon_label = /** @type {(inputs: Shipping_Addon_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlicher Versandkostenaufschlag`)
};

const id_shipping_addon_label = /** @type {(inputs: Shipping_Addon_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya Tambahan Pengiriman Bulanan`)
};

/** @type {(inputs: Shipping_Addon_LabelInputs) => LocalizedString} */
const ja_shipping_addon_label = en_shipping_addon_label;

/** @type {(inputs: Shipping_Addon_LabelInputs) => LocalizedString} */
const zh_shipping_addon_label = en_shipping_addon_label;

/** @type {(inputs: Shipping_Addon_LabelInputs) => LocalizedString} */
const ar_shipping_addon_label = en_shipping_addon_label;

/** @type {(inputs: Shipping_Addon_LabelInputs) => LocalizedString} */
const it_shipping_addon_label = en_shipping_addon_label;

/** @type {(inputs: Shipping_Addon_LabelInputs) => LocalizedString} */
const ru_shipping_addon_label = en_shipping_addon_label;

/** @type {(inputs: Shipping_Addon_LabelInputs) => LocalizedString} */
const pt_shipping_addon_label = en_shipping_addon_label;

/** @type {(inputs: Shipping_Addon_LabelInputs) => LocalizedString} */
const ko_shipping_addon_label = en_shipping_addon_label;

/**
* | output |
* | --- |
* | "Monthly Shipping Fee Surcharge" |
*
* @param {Shipping_Addon_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_addon_label = /** @type {((inputs?: Shipping_Addon_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Addon_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_addon_label(inputs)
	if (locale === "es") return es_shipping_addon_label(inputs)
	if (locale === "fr") return fr_shipping_addon_label(inputs)
	if (locale === "de") return de_shipping_addon_label(inputs)
	if (locale === "ja") return ja_shipping_addon_label(inputs)
	if (locale === "zh") return zh_shipping_addon_label(inputs)
	if (locale === "ar") return ar_shipping_addon_label(inputs)
	if (locale === "id") return id_shipping_addon_label(inputs)
	if (locale === "it") return it_shipping_addon_label(inputs)
	if (locale === "ru") return ru_shipping_addon_label(inputs)
	if (locale === "pt") return pt_shipping_addon_label(inputs)
	return ko_shipping_addon_label(inputs)
});